import React from 'react'
import { Box, Typography, TextField } from '@mui/material'
import ValidationErrorText from '../common/ValidationErrorText'

const FormTextInput = ({ label, value, readOnly = false, placeholder = '', onChange,fieldError }) => {

  return (
    <Box sx={{ width: '100%' }}>
      <Typography fontSize="14px" fontWeight="500" mb={0.5}>
        {label}
      </Typography>
      <TextField
        fullWidth
        value={value}
        placeholder={placeholder}
        onChange={(e) => !readOnly && onChange(e.target.value)}
        InputProps={{ readOnly }}
        disabled={readOnly}
        sx={{
          '& .MuiInputBase-root': {
            height: 38,
            paddingRight: 1,
          },
          '& .MuiOutlinedInput-input': {
            padding: '8px 12px',
            fontSize: '13px',
          },
        }}
      />
      <ValidationErrorText error={fieldError}/>
    </Box>
  )
}

export default FormTextInput
